/** Compatibility for the retired combined trade navigation, without adding grants. */
export function legacyTradeDestination(
  normalizedUrl: string,
  hasAccess: (url: string) => boolean
): string | null {
  const suffixes: Record<string, string> = {
    'import-export': '',
    'import-export/documents': '/documents',
    'import-export/reports': '/reports',
    'import-export/master/setup': '/master/setup'
  };
  if (!Object.prototype.hasOwnProperty.call(suffixes, normalizedUrl))
    return null;
  // With both modules available the historical default remains Import.
  // Export-only users stay within Export; no permission is inferred from a legacy grant.
  for (const direction of ['import', 'export']) {
    const destination = 'import-export/' + direction + suffixes[normalizedUrl];
    if (hasAccess(destination)) return destination;
  }
  return null;
}
